import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editActions", "cardLink", "toggleLabel"]
  static values = {
    editing: { type: Boolean, default: false },
    editLabel: String,
    previewLabel: String
  }

  toggle () {
    this.editingValue = !this.editingValue
  }

  editingValueChanged () {
    this.element.classList.toggle("is-editing", this.editingValue)

    this.editActionsTargets.forEach((el) => {
      el.classList.toggle("hidden", !this.editingValue)
    })

    this.cardLinkTargets.forEach((el) => {
      el.classList.toggle("pointer-events-none", this.editingValue)
    })

    if (this.hasToggleLabelTarget) {
      this.toggleLabelTarget.textContent = this.editingValue
        ? this.previewLabelValue
        : this.editLabelValue
    }
  }
}
